import React from 'react';
import Select, { ValueType } from 'react-select';
import { TftfSelect } from '../../../assets/theme/StyledComponents';
import configs, { ISymbolConfig } from '../../../redux/chart-iq/chart/config';
import { ChartResponsiveSize } from '../Chart';

interface IChartSymbolProps {
  ciq?: any,
  symbol?: string,
  setSymbolAndSave: (symbol: string) => void,
  responsiveSize?: string,
}

export const ChartSymbol: React.FunctionComponent<IChartSymbolProps> = ({ ciq, symbol, setSymbolAndSave, responsiveSize}) => {

	const onSelectChanged = (item: ValueType<ISymbolConfig, false>) => {
    if (!item) { return; }
    if (Array.isArray(item)) { return; }
    const selectedItem = item as ISymbolConfig
    setSymbolAndSave(selectedItem.id)
  };

  const getPlaceholderText = () => {
    switch (responsiveSize) {
      case (ChartResponsiveSize.MEDIUM):
        return 'Symbol';
      case (ChartResponsiveSize.SMALL):
        return 'Sym';
      default:
        return 'Choose Symbol';
    }
  }

  return (
    <div style={{ width: '220px' }}>
      <TftfSelect>
        <Select<ISymbolConfig>
          placeholder={getPlaceholderText()}
          className="react-select"
          classNamePrefix="react-select"
          value={configs.symbols.find(item => item.id === symbol)}
          options={configs.symbols}
          isClearable={false}
          onChange={onSelectChanged} />
      </TftfSelect>
    </div>
  );
}
